import {
  AcquisitionChannel,
  AmountOfEmployees,
  DeclaredBusinessType,
  isValidCIF,
  isValidDocumentNumber,
  MerchantCategory,
  Turnover,
} from '@nemuru-eng/js-api-client';
import { z } from 'zod';

import { GetTextIdTranslationType } from '@/components/shared/hooks/useTranslation';
import { requiredEmail, requiredEnum, requiredString } from '@/utils/zodUtils';
import { validatePhoneNumber } from '@/utils/zodValidation/validatePhoneNumber';

export const MerchantRegistrationDataFormSchema = (t: GetTextIdTranslationType) =>
  z
    .object({
      businessName: requiredString(t),
      corporateIdNumber: requiredString(t),
      postalCode: requiredString(t),
      category: requiredEnum(MerchantCategory, t),
      declaredBusinessType: requiredEnum(DeclaredBusinessType, t),
      amountOfEmployees: requiredEnum(AmountOfEmployees, t),
      acquisitionChannel: requiredEnum(AcquisitionChannel, t),
      turnover: requiredEnum(Turnover, t),
      firstName: requiredString(t),
      lastName: requiredString(t),
      phoneNumber: requiredString(t),
      email: requiredEmail(t),
    })
    .strict()
    .refine((data) => validatePhoneNumber(data.phoneNumber), {
      message: t('INVALID_PHONE_NUMBER'),
      path: ['phoneNumber'],
    })
    .refine(
      (data) =>
        data.declaredBusinessType === DeclaredBusinessType.LTD
          ? isValidCIF(data.corporateIdNumber)
          : isValidDocumentNumber(data.corporateIdNumber),
      {
        message: t('INVALID_DOCUMENT_NUMBER'),
        path: ['corporateIdNumber'],
      },
    );

export type MerchantRegistrationDataFormType = z.infer<ReturnType<typeof MerchantRegistrationDataFormSchema>>;
